import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_TRIGGER_NOW_MUTATION } from './ccaTriggerNow.mutation';
import { CcaTriggerNowMutation, CcaTriggerNowMutationVariables } from './__generated__/CcaTriggerNowMutation';

export const useCcaTriggerNow = () => {
  return useMutation<CcaTriggerNowMutation, CcaTriggerNowMutationVariables>(CCA_TRIGGER_NOW_MUTATION, {
    client: kmsClient
  });
};
